export default __webpack_public_path__ + "static/media/Lisa 9781408347256.57990a67.jpg";